/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/label-has-for */

import React, { Component } from 'react';
import { Card, CardBody, Col, Button, Table, Input } from 'reactstrap';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import axios from 'axios';
import { connect } from 'react-redux';

const URL = 'https://api.musicmarquee.co.uk';

const emptyClient = {
  company_name: '',
  contact_name: '',
  company_address: '',
  email: '',
  phone: '',
  order_fee: '',
  order_item_fee: '',
  fulfillment_location_id: 1,
  fulfillment_bandcamp: false,
  fulfillment_shopify: false,
  vat_number: '',
  storage_charges: '',
};

const emptyShopifyConfig = clientId => ({
  client_id: clientId,
  shop_name: '',
  access_token: '',
  fulfilment_location: '',
  api_key: '',
  api_secret: '',
  ioss_number: '',
});

const authHeaders = () => ({ Authorization: localStorage.getItem('mm_admin') });

class ToolsManageClientsPage extends Component {
  constructor() {
    super();
    this.state = {
      clients: [],
      bands: [],
      shopifyConfigs: [],
      selectedClient: undefined,
      clientDraft: undefined,
      shopifyDraft: undefined,
      loadingClients: false,
      loadingBands: false,
      loadingShopifyConfigs: false,
      isEditing: false,
      isAdding: false,
      bandFilter: 'unassigned',
      bandSearch: '',
      shopifyFilter: 'unassigned',
      shopifySearch: '',
      selectedShopName: '',
      saveMessage: '',
      bandSaveMessage: '',
      shopifySaveMessage: '',
      shopifyAssignMessage: '',
      showAccessToken: false,
      showApiSecret: false,
    };

    this.fetchClients = this.fetchClients.bind(this);
    this.fetchBands = this.fetchBands.bind(this);
    this.fetchShopifyConfigs = this.fetchShopifyConfigs.bind(this);
    this.selectClient = this.selectClient.bind(this);
    this.startAddingClient = this.startAddingClient.bind(this);
    this.handleClientChange = this.handleClientChange.bind(this);
    this.handleShopifyChange = this.handleShopifyChange.bind(this);
    this.saveClient = this.saveClient.bind(this);
    this.saveBandcampAssignments = this.saveBandcampAssignments.bind(this);
    this.assignShopifyConfig = this.assignShopifyConfig.bind(this);
    this.saveShopifyConfig = this.saveShopifyConfig.bind(this);
  }

  componentDidMount() {
    this.fetchClients();
    this.fetchBands();
    this.fetchShopifyConfigs();
  }

  getFulfillmentLocationName(locationId) {
    switch (parseInt(locationId, 10)) {
      case 1:
        return 'Orpington';
      case 2:
        return 'Gosport';
      default:
        return '';
    }
  }

  async fetchClients() {
    this.setState({ loadingClients: true });
    const response = await axios.post(`${URL}/admin/clients/list`, {}, { headers: authHeaders() });
    this.setState({
      clients: response.data.clients || [],
      loadingClients: false,
    });
  }

  async fetchBands() {
    this.setState({ loadingBands: true });
    const response = await axios.post(`${URL}/admin/clients/bandcamp/bands`, {}, { headers: authHeaders() });
    this.setState({
      bands: response.data.bands || [],
      loadingBands: false,
    });
  }

  async fetchShopifyConfigs() {
    this.setState({ loadingShopifyConfigs: true });
    const response = await axios.post(`${URL}/admin/clients/shopify/configs`, {}, { headers: authHeaders() });
    this.setState({
      shopifyConfigs: response.data.configs || [],
      loadingShopifyConfigs: false,
    });
  }

  async fetchShopifyConfig(clientId) {
    const response = await axios.post(`${URL}/admin/clients/shopify/config`, {
      client_id: clientId,
    }, { headers: authHeaders() });

    this.setState({
      shopifyDraft: response.data.config || emptyShopifyConfig(clientId),
      selectedShopName: response.data.config ? response.data.config.shop_name : '',
      shopifySaveMessage: '',
      shopifyAssignMessage: '',
      showAccessToken: false,
      showApiSecret: false,
    });
  }

  selectClient(client) {
    const clientDraft = { ...client };
    this.setState({
      selectedClient: client,
      clientDraft,
      isEditing: false,
      isAdding: false,
      saveMessage: '',
      bandSaveMessage: '',
      shopifyAssignMessage: '',
    });

    if (client.fulfillment_shopify) {
      this.fetchShopifyConfig(client.client_id);
    } else {
      this.setState({ shopifyDraft: emptyShopifyConfig(client.client_id) });
    }
  }

  startAddingClient() {
    this.setState({
      selectedClient: undefined,
      clientDraft: { ...emptyClient },
      shopifyDraft: undefined,
      selectedShopName: '',
      isAdding: true,
      isEditing: true,
      saveMessage: '',
      bandSaveMessage: '',
      shopifySaveMessage: '',
      shopifyAssignMessage: '',
    });
  }

  handleClientChange(e) {
    const clientDraft = { ...this.state.clientDraft };
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    clientDraft[e.target.name] = value;
    this.setState({ clientDraft });

    if (e.target.name === 'fulfillment_shopify' && value && clientDraft.client_id) {
      this.fetchShopifyConfig(clientDraft.client_id);
    }
  }

  handleShopifyChange(e) {
    const shopifyDraft = { ...this.state.shopifyDraft };
    shopifyDraft[e.target.name] = e.target.value;
    this.setState({ shopifyDraft });
  }

  async saveClient() {
    const endpoint = this.state.clientDraft.client_id
      ? `${URL}/admin/clients/update`
      : `${URL}/admin/clients/create`;

    const response = await axios.post(endpoint, {
      client: this.state.clientDraft,
    }, { headers: authHeaders() });

    if (response.data.error) {
      this.setState({ saveMessage: response.data.error.message || 'Unable to save client.' });
      return;
    }

    const savedClient = response.data.client;

    await this.fetchClients();
    this.setState({
      selectedClient: savedClient,
      clientDraft: savedClient,
      isAdding: false,
      isEditing: false,
      saveMessage: 'Client saved.',
    });

    if (savedClient.fulfillment_shopify) {
      this.fetchShopifyConfig(savedClient.client_id);
    }
  }

  toggleBandAssignment(band) {
    const clientId = this.state.selectedClient.client_id;
    const clientName = this.state.clientDraft.company_name;
    const bands = this.state.bands.map((existingBand) => {
      const isSameBand = existingBand.band_id === band.band_id
        && existingBand.parent_band_id === band.parent_band_id;

      if (!isSameBand) {
        return existingBand;
      }

      if (existingBand.client_id === clientId) {
        return {
          ...existingBand,
          client_id: null,
          current_client_name: null,
        };
      }

      return {
        ...existingBand,
        client_id: clientId,
        current_client_name: clientName,
        fulfilment_location: this.state.clientDraft.fulfillment_location_id,
      };
    });

    this.setState({ bands, bandSaveMessage: '' });
  }

  async saveBandcampAssignments() {
    const selectedBands = this.state.bands
      .filter(band => band.client_id === this.state.selectedClient.client_id)
      .map(band => ({
        band_id: band.band_id,
        parent_band_id: band.parent_band_id,
      }));

    const response = await axios.post(`${URL}/admin/clients/bandcamp/assign`, {
      client_id: this.state.selectedClient.client_id,
      fulfilment_location: this.state.clientDraft.fulfillment_location_id,
      bands: selectedBands,
    }, { headers: authHeaders() });

    if (response.data.error) {
      this.setState({ bandSaveMessage: response.data.error.message || 'Unable to save band assignments.' });
      return;
    }

    this.setState({
      bands: response.data.bands || [],
      bandSaveMessage: 'Band assignments saved.',
    });
    this.fetchClients();
  }

  async assignShopifyConfig() {
    if (!this.state.selectedShopName) {
      this.setState({ shopifyAssignMessage: 'Select a Shopify store first.' });
      return;
    }

    const response = await axios.post(`${URL}/admin/clients/shopify/assign`, {
      client_id: this.state.selectedClient.client_id,
      shop_name: this.state.selectedShopName,
    }, { headers: authHeaders() });

    if (response.data.error) {
      this.setState({ shopifyAssignMessage: response.data.error.message || 'Unable to assign Shopify store.' });
      return;
    }

    this.setState({
      shopifyConfigs: response.data.configs || [],
      shopifyDraft: response.data.config,
      shopifyAssignMessage: 'Shopify store assigned.',
      shopifySaveMessage: '',
    });
    this.fetchClients();
  }

  async saveShopifyConfig() {
    const response = await axios.post(`${URL}/admin/clients/shopify/config/update`, {
      config: {
        ...this.state.shopifyDraft,
        client_id: this.state.selectedClient.client_id,
      },
    }, { headers: authHeaders() });

    if (response.data.error) {
      this.setState({ shopifySaveMessage: response.data.error.message || 'Unable to save Shopify config.' });
      return;
    }

    this.setState({
      shopifyDraft: response.data.config,
      shopifySaveMessage: 'Shopify config saved.',
    });
    this.fetchClients();
    this.fetchShopifyConfigs();
  }

  filteredBands() {
    const search = this.state.bandSearch.toLowerCase();
    const selectedClientId = this.state.selectedClient ? this.state.selectedClient.client_id : null;

    return this.state.bands.filter((band) => {
      const text = `${band.name || ''} ${band.subdomain || ''}`.toLowerCase();
      const matchesSearch = text.indexOf(search) !== -1;

      if (!matchesSearch) {
        return false;
      }

      if (this.state.bandFilter === 'unassigned') {
        return !band.client_id || band.client_id === selectedClientId;
      }

      return true;
    });
  }

  filteredShopifyConfigs() {
    const search = this.state.shopifySearch.toLowerCase();
    const selectedClientId = this.state.selectedClient ? this.state.selectedClient.client_id : null;

    return this.state.shopifyConfigs.filter((config) => {
      const text = `${config.shop_name || ''} ${config.current_client_name || ''}`.toLowerCase();
      const matchesSearch = text.indexOf(search) !== -1;

      if (!matchesSearch) {
        return false;
      }

      if (this.state.shopifyFilter === 'unassigned') {
        return parseInt(config.client_id, 10) === 0 || config.client_id === selectedClientId;
      }

      return true;
    });
  }

  renderClientForm() {
    if (!this.state.clientDraft) {
      return null;
    }

    const disabled = !this.state.isEditing;

    return (
      <Card style={{ marginTop: '15px' }}>
        <CardBody>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <h4>{this.state.isAdding ? 'Add Client' : this.state.clientDraft.company_name}</h4>
            <div>
              {!this.state.isAdding ? (
                <Button
                  color="primary"
                  size="sm"
                  disabled={this.state.isEditing}
                  onClick={() => this.setState({ isEditing: true, saveMessage: '' })}
                >
                  Edit Client
                </Button>
              ) : null}
              {this.state.isEditing ? (
                <Button
                  color="secondary"
                  size="sm"
                  style={{ marginLeft: '5px' }}
                  onClick={() => {
                    if (this.state.selectedClient) {
                      this.selectClient(this.state.selectedClient);
                    } else {
                      this.setState({ clientDraft: undefined, isAdding: false, isEditing: false });
                    }
                  }}
                >
                  Cancel
                </Button>
              ) : null}
            </div>
          </div>

          <Table bordered size="sm" style={{ marginTop: '10px' }}>
            <tbody>
              <tr>
                <th>Company Name</th>
                <td><Input disabled={disabled} name="company_name" value={this.state.clientDraft.company_name || ''} onChange={this.handleClientChange} /></td>
                <th>Contact Name</th>
                <td><Input disabled={disabled} name="contact_name" value={this.state.clientDraft.contact_name || ''} onChange={this.handleClientChange} /></td>
              </tr>
              <tr>
                <th>Email</th>
                <td><Input disabled={disabled} name="email" value={this.state.clientDraft.email || ''} onChange={this.handleClientChange} /></td>
                <th>Phone</th>
                <td><Input disabled={disabled} name="phone" value={this.state.clientDraft.phone || ''} onChange={this.handleClientChange} /></td>
              </tr>
              <tr>
                <th>Address</th>
                <td colSpan="3">
                  <Input
                    type="textarea"
                    rows="3"
                    disabled={disabled}
                    name="company_address"
                    value={this.state.clientDraft.company_address || ''}
                    onChange={this.handleClientChange}
                  />
                </td>
              </tr>
              <tr>
                <th>Order Fee</th>
                <td><Input disabled={disabled} type="number" step="0.01" name="order_fee" value={this.state.clientDraft.order_fee || ''} onChange={this.handleClientChange} /></td>
                <th>Order Item Fee</th>
                <td><Input disabled={disabled} type="number" step="0.01" name="order_item_fee" value={this.state.clientDraft.order_item_fee || ''} onChange={this.handleClientChange} /></td>
              </tr>
              <tr>
                <th>Storage Charges</th>
                <td><Input disabled={disabled} type="number" step="0.01" name="storage_charges" value={this.state.clientDraft.storage_charges || ''} onChange={this.handleClientChange} /></td>
                <th>VAT Number</th>
                <td><Input disabled={disabled} name="vat_number" value={this.state.clientDraft.vat_number || ''} onChange={this.handleClientChange} /></td>
              </tr>
              <tr>
                <th>Fulfilment Location</th>
                <td>
                  <Input disabled={disabled} type="select" name="fulfillment_location_id" value={this.state.clientDraft.fulfillment_location_id || ''} onChange={this.handleClientChange}>
                    <option value={1}>Orpington</option>
                    <option value={2}>Gosport</option>
                  </Input>
                </td>
                <th>Channels</th>
                <td>
                  <label style={{ marginRight: '15px' }}>
                    <Input
                      disabled={disabled}
                      type="checkbox"
                      name="fulfillment_bandcamp"
                      checked={!!this.state.clientDraft.fulfillment_bandcamp}
                      onChange={this.handleClientChange}
                    />
                    {' '}Bandcamp
                  </label>
                  <label>
                    <Input
                      disabled={disabled}
                      type="checkbox"
                      name="fulfillment_shopify"
                      checked={!!this.state.clientDraft.fulfillment_shopify}
                      onChange={this.handleClientChange}
                    />
                    {' '}Shopify
                  </label>
                </td>
              </tr>
            </tbody>
          </Table>

          {this.state.isEditing ? (
            <Button color="primary" size="sm" onClick={this.saveClient}>
              Save Client
            </Button>
          ) : null}
          <span style={{ marginLeft: '10px' }}>{this.state.saveMessage}</span>
        </CardBody>
      </Card>
    );
  }

  renderBandcampSection() {
    if (!this.state.selectedClient || !this.state.clientDraft.fulfillment_bandcamp) {
      return null;
    }

    const bands = this.filteredBands();

    return (
      <Card style={{ marginTop: '15px' }}>
        <CardBody>
          <h4>Bandcamp Bands</h4>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <Input type="select" value={this.state.bandFilter} onChange={e => this.setState({ bandFilter: e.target.value })} style={{ maxWidth: '220px' }}>
              <option value="unassigned">Unassigned / this client</option>
              <option value="all">All bands</option>
            </Input>
            <Input
              placeholder="Search band name or subdomain"
              value={this.state.bandSearch}
              onChange={e => this.setState({ bandSearch: e.target.value })}
            />
            <Button color="primary" size="sm" onClick={this.saveBandcampAssignments}>
              Save Band Assignments
            </Button>
          </div>
          <div style={{ maxHeight: '420px', overflow: 'auto' }}>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th style={{ width: '80px' }}>Assign</th>
                  <th>Band Name</th>
                  <th>Parent Band</th>
                  <th>Subdomain</th>
                  <th>Current Client</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                {bands.map((band, index) => (
                  <tr key={`${band.band_id}-${band.parent_band_id}-${index}`}>
                    <td>
                      <Input
                        type="checkbox"
                        style={{ position: 'static', marginLeft: 0 }}
                        checked={band.client_id === this.state.selectedClient.client_id}
                        onChange={() => this.toggleBandAssignment(band)}
                      />
                    </td>
                    <td>{band.name}</td>
                    <td>{band.parent_band_name || 'Top level'}</td>
                    <td>{band.subdomain}</td>
                    <td>{band.current_client_name || 'Unassigned'}</td>
                    <td>{this.getFulfillmentLocationName(band.fulfilment_location)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <span>{this.state.bandSaveMessage}</span>
        </CardBody>
      </Card>
    );
  }

  renderSecretInput(name, label, visibleStateName) {
    const visible = this.state[visibleStateName];

    return (
      <tr>
        <th>{label}</th>
        <td>
          <div style={{ display: 'flex', gap: '5px' }}>
            <Input
              type={visible ? 'text' : 'password'}
              name={name}
              value={this.state.shopifyDraft[name] || ''}
              onChange={this.handleShopifyChange}
            />
            <Button
              color="secondary"
              size="sm"
              onClick={() => this.setState(prevState => ({ [visibleStateName]: !prevState[visibleStateName] }))}
            >
              {visible ? 'Hide' : 'Show'}
            </Button>
          </div>
        </td>
      </tr>
    );
  }

  renderShopifySection() {
    if (!this.state.selectedClient || !this.state.clientDraft.fulfillment_shopify || !this.state.shopifyDraft) {
      return null;
    }

    const shopifyConfigs = this.filteredShopifyConfigs();

    return (
      <Card style={{ marginTop: '15px' }}>
        <CardBody>
          <h4>Shopify Stores</h4>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
            <Input type="select" value={this.state.shopifyFilter} onChange={e => this.setState({ shopifyFilter: e.target.value })} style={{ maxWidth: '220px' }}>
              <option value="unassigned">Unassigned / this client</option>
              <option value="all">All stores</option>
            </Input>
            <Input
              placeholder="Search shop name or client"
              value={this.state.shopifySearch}
              onChange={e => this.setState({ shopifySearch: e.target.value })}
            />
            <Button color="primary" size="sm" onClick={this.assignShopifyConfig}>
              Assign Store
            </Button>
          </div>
          <div style={{ maxHeight: '260px', overflow: 'auto', marginBottom: '10px' }}>
            <Table striped bordered hover size="sm">
              <thead>
                <tr>
                  <th style={{ width: '80px' }}>Assign</th>
                  <th>Shop Name</th>
                  <th>Current Client</th>
                  <th>Fulfilment Location</th>
                  <th>IOSS Number</th>
                </tr>
              </thead>
              <tbody>
                {shopifyConfigs.map((config, index) => (
                  <tr key={`${config.shop_name}-${index}`}>
                    <td>
                      <Input
                        type="radio"
                        name="selected_shopify_config"
                        style={{ position: 'static', marginLeft: 0 }}
                        checked={this.state.selectedShopName === config.shop_name}
                        onChange={() => this.setState({
                          selectedShopName: config.shop_name,
                          shopifyAssignMessage: '',
                        })}
                      />
                    </td>
                    <td>{config.shop_name}</td>
                    <td>{config.current_client_name || 'Unassigned'}</td>
                    <td>{config.fulfilment_location}</td>
                    <td>{config.ioss_number}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <span>{this.state.shopifyAssignMessage}</span>
          <h4 style={{ marginTop: '15px' }}>Shopify Config</h4>
          <Table bordered size="sm">
            <tbody>
              <tr>
                <th>Shop Name</th>
                <td><Input name="shop_name" value={this.state.shopifyDraft.shop_name || ''} onChange={this.handleShopifyChange} /></td>
              </tr>
              {this.renderSecretInput('access_token', 'Access Token', 'showAccessToken')}
              <tr>
                <th>Fulfilment Location</th>
                <td><Input name="fulfilment_location" value={this.state.shopifyDraft.fulfilment_location || ''} onChange={this.handleShopifyChange} /></td>
              </tr>
              <tr>
                <th>API Key</th>
                <td><Input name="api_key" value={this.state.shopifyDraft.api_key || ''} onChange={this.handleShopifyChange} /></td>
              </tr>
              {this.renderSecretInput('api_secret', 'API Secret', 'showApiSecret')}
              <tr>
                <th>IOSS Number</th>
                <td><Input name="ioss_number" value={this.state.shopifyDraft.ioss_number || ''} onChange={this.handleShopifyChange} /></td>
              </tr>
            </tbody>
          </Table>
          <Button color="primary" size="sm" onClick={this.saveShopifyConfig}>
            Save Shopify Config
          </Button>
          <span style={{ marginLeft: '10px' }}>{this.state.shopifySaveMessage}</span>
        </CardBody>
      </Card>
    );
  }

  render() {
    const columns = [
      {
        Header: 'ID',
        accessor: 'client_id',
        width: 70,
      }, {
        Header: 'Company',
        accessor: 'company_name',
      }, {
        Header: 'Contact',
        accessor: 'contact_name',
      }, {
        Header: 'Bandcamp',
        id: 'fulfillment_bandcamp',
        accessor: d => (d.fulfillment_bandcamp ? 'Yes' : 'No'),
        width: 100,
      }, {
        Header: 'Shopify',
        id: 'fulfillment_shopify',
        accessor: d => (d.fulfillment_shopify ? 'Yes' : 'No'),
        width: 100,
      }, {
        Header: 'Bands',
        accessor: 'bandcamp_band_count',
        width: 80,
      }, {
        Header: 'Shop',
        accessor: 'shop_name',
      },
    ];

    return (
      <Col>
        <Card>
          <CardBody>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px',
              }}
            >
              <h3>Manage Clients</h3>
              <Button color="primary" size="sm" onClick={this.startAddingClient}>
                Add New Client
              </Button>
            </div>
            <ReactTable
              data={this.state.clients}
              columns={columns}
              loading={this.state.loadingClients}
              filterable
              defaultPageSize={20}
              className="-striped -highlight -responsive"
              getTrProps={(state, rowInfo) => {
                if (rowInfo !== undefined) {
                  return {
                    onClick: () => this.selectClient(rowInfo.original),
                    style: {
                      background: this.state.selectedClient
                        && rowInfo.original.client_id === this.state.selectedClient.client_id ? '#00afec' : 'white',
                      color: this.state.selectedClient
                        && rowInfo.original.client_id === this.state.selectedClient.client_id ? 'white' : 'black',
                    },
                  };
                }
                return {};
              }}
            />
          </CardBody>
        </Card>
        {this.renderClientForm()}
        {this.renderBandcampSection()}
        {this.renderShopifySection()}
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(ToolsManageClientsPage);
